import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"15px"} }, "Select a checklist the standard user for this employee has access to. Check department and location settings if a checklist is not showing here.", -1)),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checklistInput) = $event))
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "Select a checklist", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allChecklists, (c, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: c,
                    key: i
                  }, _toDisplayString(c.Name), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.checklistInput]
              ]),
              _createElementVNode("div", {
                style: {"margin":"5px 0 0 10px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addChecklist()))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", {
                  class: "btn",
                  style: {"margin":"0"}
                }, "Add", -1)
              ]))])
            ]),
            _createVNode(_component_draggable, {
              list: _ctx.selectedChecklists,
              class: "config-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedChecklists, (c, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    style: {"cursor":"default"}
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        href: '/playbook/'+c.Slug,
                        target: "_blank"
                      }, _toDisplayString(c.Name), 9, _hoisted_6)
                    ]),
                    _createVNode(_component_svg_icon, {
                      icon: "x",
                      onClick: ($event: any) => (_ctx.removeChecklist(i))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["list"]),
            _createElementVNode("input", {
              style: {"margin-top":"15px"},
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}